﻿$.fn.dxCtrlBuilderEmailHtmlEditor = function custom_dxCtrlBuilderEmailHtmlEditor(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailhtmleditor dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailHtmlEditor(this, option));
    }
    return this;
}

window.idxInstanceWidgetHtmlEditor = 0
window.cdxCtrlBuilderEmailHtmlEditor = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var indexInstance = indexHtmlEditor
    indexHtmlEditor += 1

    var editorHtml = null
    function mConstruit() {
        container.css("height", ((container.innerHeight() > 0) ? container.innerHeight() + "px" : ""))
        container.css("height", "100%")
        container.empty();

        var $DivToolBar = $("<div id='divhtmltoolbar" + indexInstance + "' class='' style='background-color:transparent'/>").appendTo(container)
        var $DivEdit = $("<div id='diveditWidgetHtmlEditor" + indexInstance + "' style='padding:0 5px;height:100%;border-radius:0;border:none;overflow:auto;' class=''/>").appendTo(container)
        resizeObserver.mAdd($DivToolBar, function () { $DivEdit.css("height", "calc(100% - " + $DivToolBar.innerHeight() + "px)") })

        var toolBarBase = "fontfamily fontsize | bold italic underline forecolor removeformat | lineheight align outdent indent bullist | link linkbox" + indexInstance + " linksondage" + indexInstance + " linkformulaire" + indexInstance + " emoticons imagebuilder" + indexInstance + " | tag" + indexInstance + " | reformulationia" + indexInstance + " cboTranslateIa" + indexInstance + " | showhidemenu" + indexInstance + " toggleToolbar"

        if (!option.content_style) option.content_style = ""
        option.content_style += `
            .champdoc {
                background: repeating-linear-gradient(
                    45deg,
                    #dce9ff,
                    #dce9ff 8px,
                    #b8d1ff 8px,
                    #b8d1ff 16px
                  );
                border-radius: 4px;
            }
            .champdocsaisie {
                background: repeating-linear-gradient(
                    45deg,
                    #ffe5cc,
                    #ffe5cc 8px,
                    #ffcc99 8px,
                    #ffcc99 16px
                );
                border-radius: 4px;
            }
            body{padding:10px 10px 0 10px}
            `

        if (!option.fontFamilyFormat) {
            option.fontFamilyFormat =
                "Roboto=Roboto, Arial, Helvetica, sans-serif;" +
                "Arial=Arial, Helvetica, sans-serif;" +
                "Helvetica=Helvetica, Arial, sans-serif;" +
                "Verdana=Verdana, Geneva, sans-serif;" +
                "Tahoma=Tahoma, Verdana, Segoe UI, sans-serif;" +
                "Trebuchet MS=Trebuchet MS, Helvetica, sans-serif;" +
                "Georgia=Georgia, Times New Roman, serif;" +
                "Times New Roman=Times New Roman, Times, serif;" +
                "Courier New=Courier New, Courier, monospace"
        }
        var opt = {
            // ⚙️ Options de base
            relative_urls: false,
            remove_script_host: false,
            convert_urls: true,
            document_base_url: parametre.url_appli + '/',
            // 🔧 Conversion d'URL personnalisée
            urlconverter_callback: function (url, node, onSave, name) {
                //try {
                //    const domain = parametre.url_appli;

                //    // On ignore les blobs (iamge qui sont les collé du presse-papier par l'utilisateur)
                //    if (url.startsWith('blob:')) return url;
                //    if (url.startsWith('mailto:')) return url;
                //    if (url.startsWith('tel:')) return url;
                //    if (url.startsWith('cid:')) return url;
                //    if (url.startsWith('data:')) return url;
                //    if (url.startsWith('ftp:')) return url;
                //    if (url.startsWith('file:')) return url;
                //    if (url.startsWith('javascript:')) return url;

                //    // Cas 1 : URL absolue du même domaine → on enlève le domaine
                //    if (url.startsWith(domain)) {
                //        url = '/' + url.substring(domain.length).replace(/^\/+/, '');
                //    }
                //    // Cas 2 : URL relative sans slash au début → on ajoute le slash
                //    else if (!url.startsWith('http') && !url.startsWith('/') && !url.startsWith('data:')) {
                //        url = '/' + url;
                //    }

                //    // sinon (externe, data:image, etc.), on ne touche pas
                //    return url;
                //} catch (e) {
                //    return url;
                //}
                try {
                    const domain = parametre.url_appli.replace(/\/+$/, '');

                    if (/^(blob|mailto|tel|cid|data|ftp|file|javascript):/i.test(url)) return url;

                    // Réparation des URL encodées par encodeURIComponent (/%2Ffichier%2F...)
                    if (/^\/?%2F/i.test(url)) {
                        url = '/' + decodeURIComponent(url).replace(/^\/+/, '');
                    }

                    // Cas 1 : même domaine → chemin absolu sans domaine
                    if (url.startsWith(domain)) {
                        url = '/' + url.substring(domain.length).replace(/^\/+/, '');
                    }
                    // Cas 2 : relatif sans slash → on ajoute le slash
                    else if (!/^https?:/i.test(url) && !url.startsWith('/')) {
                        url = '/' + url;
                    }

                    // Supprime les doubles slashs dans le chemin (hors "http://")
                    if (url.startsWith('/')) url = url.replace(/\/{2,}/g, '/');

                    return url;
                } catch (e) {
                    return url;
                }
            },
            selector: "#diveditWidgetHtmlEditor" + indexInstance,
            height: "100%",
            browser_spellcheck: true,
            contextmenu: false, //for spellchecking
            valid_children: '+a[table],+span[table]',  // valid_children: '+span[table]', //le + permet de spécifier un rajout de "valid_children"
            inline: false, //((typeof option.inline != 'undefined') ? option.inline : false),
            skin: 'oxide-dark',        // Name of the skin  // change this value according to your HTML
            content_style: option.content_style,
            //content_css: parametre.urldispatch + "/js/plugin/tinymce/skins/content.min.css?v=" + parametre.version, //content_css: parametre.urldispatch + "/js/plugin/tinymce/skins/content/oxide-dark/content.min.css?v=" + parametre.version,
            ////mode: "exact",
            entity_encoding: "raw", //encodage des caractères
            keep_styles: true, //garde le style sur entrée
            forced_root_block: option.forced_root_block, //utilise <div> comme élément pour les saut de lignes plutôt que <p>
            extended_valid_elements: 'a[href|target|style],img[src|alt|style|width|height|img_default]', //pour le concepteur qui perdais les liens images
            font_family_formats: option.fontFamilyFormat, //liste des typos dispos
            line_height_formats: "50% 60% 70% 80% 90% 100% 110% 120% 130% 140% 150% 200% 220% 240% 260% 280% 300%",
            font_size_formats: '8px 10px 12px 14px 16px 18px 20px 24px 28px 32px 36px 48px',
            link_default_target: "_blank",
            paste_data_images: true,
            automatic_uploads: false, // désactive la gestion interne des blobs
            image_advtab: true,
            image_uploadtab: false,
            promotion: false,
            lists_indent_on_tab: false,
            menu: {
                file: { title: 'File', items: 'print | preview' },
                edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall | searchreplace' },
                view: { title: 'View', items: 'codeView | visualaid ' },
                insert: { title: 'Insert', items: 'link inserttable | charmap emoticons hr' },
                format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | styles blocks fontfamily fontsize align lineheight | forecolor backcolor | language | removeformat' },
                table: { title: 'Table', items: 'inserttable | cell row column | advtablesort | tableprops deletetable' }
            },
            fixed_toolbar_container: "#divhtmltoolbar" + indexInstance,
            toolbar_mode: 'sliding',
            //toolbar: toolBarBase + " imagebuilder" + indexInstance + " tag" + indexInstance + " reformulationia" + indexInstance + " cboTranslateIa" + indexInstance + " showhidemenu" + indexInstance + ' toggleToolbar',
            toolbar: toolBarBase, // + ' toggleToolbar',
            statusbar: false,
            language: 'fr_FR',
            external_plugins: {
                pluginId: parametre.urldispatch + "/js/plugin/tinymce/plugins/fullpage/plugin.min.js" //on rajoute le plugin fullpage (utiliser body)
            },
            object_resizing: 'img',
            plugins: 'lists advlist autolink charmap code emoticons link image searchreplace table fullpage preview',
            //toolbar: toolBarBase + ' toggleToolbar',
            ////toolbar_sticky: false,
            ////toolbar_persist: true,
            block_formats: 'Paragraphe=p; Titre 1=h1; Titre 2=h2; Titre 3=h3; Titre 4=h4',
            setup: function (editor) {
                editorHtml = editor;

                mAddButton();

                editor.on('paste', function (e) {
                    window.setTimeout(function () { processBlobsInEditor(editor) }, 200)
                });

                // ----------------
                // gestion image height auto
                // ----------------
                // Quand une image est insérée ou redimensionnée
                const forceAutoHeight = (img) => {
                    if (!img || img.nodeName !== 'IMG') return;
                    setTimeout(() => {
                        img.removeAttribute('height');
                        img.style.height = 'auto';
                        if (img.hasAttribute('data-mce-style')) {
                            // Nettoie la hauteur dans data-mce-style
                            const css = img.getAttribute('data-mce-style')
                                .replace(/height\s*:\s*[^;]+;?/gi, '')
                                .trim();
                            img.setAttribute('data-mce-style', css);
                        }
                    }, 30); // attendre que TinyMCE ait fini sa mise à jour
                };
                // 1️⃣ Quand on redimensionne une image
                editor.on('ObjectResized', (e) => {
                    if (e.target.nodeName === 'IMG') forceAutoHeight(e.target);
                });
                // ----------------
                // Quand du nouveau contenu est inséré (collage, drag&drop, dialogue d'image…)
                // ----------------
                editor.on('BeforeSetContent', (e) => {
                    if (!e.content) return;

                    // On parse le contenu HTML qui va être inséré
                    const div = document.createElement('div');
                    div.innerHTML = e.content;

                    // On applique height:auto uniquement sur les images du nouveau contenu
                    div.querySelectorAll('img').forEach(forceAutoHeight);

                    // On remplace le contenu par le contenu modifié
                    e.content = div.innerHTML;
                });


                //---------------------------
                //gestion width image
                //------------------------------
                //gere l'ajout du style width sur les images à l'init du content
                // 🔹 Au chargement du contenu initial (init, collage, etc.)
                editor.on('SetContent', function () {
                    editor.dom.select('img').forEach(setImageWidthStyle);
                });
                ////gere l'ajout du style width sur les images si changement node
                ////enlever le 17/12/2025 car empeche le resize des images si width défini
                ////je ne sais plus pourquoi on faisait cela
                //editor.on('NodeChange', function (e) { // Vérifie seulement les images pour limiter le coût
                //    if (e.element && e.element.nodeName === 'IMG') {
                //        setImageWidthStyle(e.element);
                //    }
                //});

                function setImageWidthStyle(img) {
                    const width = img.getAttribute('width');
                    if (!width) return;

                    // 🔹 On fusionne style et data-mce-style pour ne rien perdre
                    let rawStyle = (img.getAttribute('style') || '') + ';' + (img.getAttribute('data-mce-style') || '');

                    // 🔹 On parse les styles existants
                    const styles = {};
                    rawStyle.split(';').forEach(rule => {
                        const [prop, value] = rule.split(':').map(s => s && s.trim());
                        if (prop && value) styles[prop.toLowerCase()] = value;
                    });

                    // 🔹 Mise à jour / remplacement du width
                    styles['width'] = width + 'px';

                    // 🔹 Reconstruit proprement l’attribut style
                    const newStyle = Object.entries(styles)
                        .map(([prop, value]) => `${prop}: ${value}`)
                        .join('; ');

                    // 🔹 Applique uniquement "style" (TinyMCE gérera data-mce-style automatiquement)
                    img.setAttribute('style', newStyle);

                    // 🔹 Supprime data-mce-style pour éviter les doublons
                    img.removeAttribute('data-mce-style');
                }
                // -------------------------------------------------

                editor.on('init', (e) => {

                    const win = editor.getWin();
                    const doc = editor.getDoc();

                    const scrollViewEl = editor.getContainer().closest('.dx-scrollview');
                    const scrollView = scrollViewEl && DevExpress.ui.dxScrollView.getInstance(scrollViewEl);
                    if (!scrollView) return;

                    win.addEventListener('wheel', (e) => {
                        const el = doc.scrollingElement;
                        const atTop = el.scrollTop <= 0 && e.deltaY < 0;
                        const atBottom = Math.ceil(el.scrollTop + el.clientHeight) >= el.scrollHeight - 1 && e.deltaY > 0;

                        if (atTop || atBottom) {
                            e.preventDefault();
                            scrollView.scrollBy(e.deltaY);
                        }
                    }, { passive: false });

                    editor.iframeElement.setAttribute('title', '');
                    //on cache le menu qui est visible par défaut
                    var $Menu = container.find(".tox-menubar")
                    $Menu.css("display", "none");

                    editorHtml.on('focus', function (e) {
                        if (typeof option.onFocus != 'undefined') option.onFocus(Me)
                    });

                    editorHtml.on('blur', function (e) {
                        if (typeof option.onBlur != 'undefined') option.onBlur(Me)
                    });

                    if (1 == 1) { //!inline
                        function fireParentEvent(e, type) {
                            const evt = new MouseEvent(type, {
                                bubbles: true,
                                cancelable: true,
                                clientX: e.clientX,
                                clientY: e.clientY,
                                screenX: e.screenX,
                                screenY: e.screenY
                            });
                            document.dispatchEvent(evt);      // dans le document principal
                        }

                        const doc = $(editorHtml.getDoc()).contents();

                        // --- CLICK & MOUSEDOWN (ferme les popups DevExtreme) ---
                        doc.on("mousedown click", function (e) {
                            fireParentEvent(e, e.type);
                        });

                        // --- MOUSEUP ---
                        doc.on("mouseup", function (e) {
                            fireParentEvent(e, "mouseup");
                        });

                        // --- DRAGOVER ---
                        doc.on("dragover", function (e) {
                            fireParentEvent(e, "dragover");
                        });
                    }

                    Me.isInit = true
                    if (typeof option.html != 'undefined') {
                        editorHtml.setContent(option.html)
                    }

                    window.setTimeout(function () {
                        Me.element().find("button[title='Polices']").css("width", "110px")
                        Me.element().find("button[title='Taille de police']").css("width", "70px")
                        Me.element().find("button[title='Blocs']").css("width", "110px")
                    }, 0)

                    container.find(".tox-tinymce").css({ "width": "100%" })

                    Me.element().find(".mce-content-body").addClass("bodyassistantemail templatetext")
                    if (typeof option.onContentReady != 'undefined') option.onContentReady({ component: Me })
                    window.setTimeout(function () { container.find(".tox-editor-header").css("border-radius", "0") }, 0)
                    //container.find(".tox-editor-header").css("border-radius", "0")
                    //container.find(".tox-tinymce").css({ "width": "100%" })

                });

            },
        }
        //if (parametre.code_appli == 'ppmasc' || option.bddCtrl.nom_base == "masc_dahutemeraire") {
        opt.plugins = 'lists advlist autolink charmap emoticons link image searchreplace table preview'
        delete opt.external_plugins
        //}
        tinymce.init(opt);
        container.css("height", "")
    }

    function processBlobsInEditor(editor) {
        const imgs = editor.dom.select('img[src^="blob:"]'); // toutes les images blob
        imgs.forEach(img => {
            // créer un blobInfo fictif pour obtenir le data URL
            const blobUrl = img.src;
            const blob = editor.editorUpload.blobCache.getByUri(blobUrl)?.blob();
            if (blob) {
                console.log("Debut traitement Blob")
                var $overlay = $('<div>')
                    .css({
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        background: 'transparent',
                        'z-index': 1000000000,
                        display: 'flex',
                        'align-items': 'center',
                        'justify-content': 'center'
                    })
                    .appendTo('body');

                const reader = new FileReader();
                reader.onloadend = function () {
                    const dataUrl = reader.result; // data:image/…;base64,…

                    option.bddCtrl.mAjaxCall({
                        command: "uploadimgeditor",
                        dataurl: dataUrl,
                        filename: "image.png",
                        async: false
                    }, function (data) {
                        if (data && data.imgurl) {
                            //// remplacer le contenu collé par <img src="URL_SERVEUR">
                            //img.src = data.imgurl;
                            //////editor.setContent(e.content); // met à jour l'éditeur
                            ////Me.isDirty = true
                            editor.dom.setAttrib(img, 'src', data.imgurl);
                        }
                    }, function () {
                        $overlay.remove()
                        console.log("Fin traitement Blob")
                    });
                };
                reader.readAsDataURL(blob);
            } else {
                try {
                    throw new Error("BLOB impossible à récupérer via editor.editorUpload.blobCache.getByUri(blobUrl)?.blob()");
                } catch (e) {
                    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                }
                //mTraiteMessageJs("erreurjs", "BLOB impossible à récupérer via editor.editorUpload.blobCache.getByUri(blobUrl)?.blob()", $(location).attr("href"), 0, null, e, "orange")
            }
        });
    }

    function mAddButton() {

        editorHtml.ui.registry.addMenuItem('codeView', {
            text: 'Code source',
            //icon: 'fas fa-code',
            onAction: function () {
                const html = editorHtml.getContent({ format: 'html' });
                var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                    shading: true,
                    position: {
                        my: "right top",
                        at: "right top",
                        of: "body"
                    },
                    hideOnOutsideClick: false,
                    width: 650,
                    height: "100%",
                    showTitle: true,
                    showMaximize: true,
                    showMinimize: false,
                    title: "Code source",
                    contentTemplate: function (contentElement) {
                        contentElement.css("padding", "0 20px 10px 20px")
                        var $txtArea = $("<textarea id='code-editor' style='height:100%;'></textarea>").appendTo(contentElement)
                        var codeMirrorEditor = CodeMirror.fromTextArea($txtArea[0], {
                            mode: 'htmlmixed',
                            lineNumbers: true,
                            lineWrapping: true,
                            theme: 'default'
                        });
                        codeMirrorEditor.setValue(html);
                        codeMirrorEditor.refresh();

                        var $Table = mAddButtonOkAnnuler(contentElement,
                            function () { //ok
                                const newContent = codeMirrorEditor.getValue();
                                editorHtml.setContent(newContent);
                                isDirty = true
                                popup.hide();
                            },
                            function () { //annuler
                                popup.hide();
                            }).table
                        $Table.css("margin-top", "10px")
                        $(codeMirrorEditor.getWrapperElement()).css({
                            "height": "calc(100% - " + ($Table.innerHeight() + 10) + "px)"
                        }).table
                    }

                }).dxCtrlPopupBase("instance")
                popup.show()
            }
        });

        //button pour gérer les images
        editorHtml.ui.registry.addIcon('imagebuilder' + indexInstance, '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 512 512"><path d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"/></svg>');
        editorHtml.ui.registry.addButton('imagebuilder' + indexInstance, {
            id: 'imagebuilder_' + indexInstance,
            icon: 'imagebuilder' + indexInstance,
            tooltip: 'Image',
            onPostRender: function (ed) {
                var ctrl = this;
                ed.on('NodeChange', function (e) {
                    ctrl.active(e.element.nodeName.toLowerCase() == 'img');
                });
            },
            onAction: function (e) {
                var node = editorHtml.selection.getNode();
                if (node.nodeName.toLowerCase() == "img") {
                    editorHtml.execCommand('mceImage');
                } else {
                    var pop = $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                        bddCtrl: option.bddCtrl,
                        imgInternet: false,
                        imgPexel: true,
                        multiple: false,
                        accept: ".png,.jpg,.jpeg,.gif,.bmp",
                        onValide: function (lstUrlFile) {
                            if (lstUrlFile.length > 0) {
                                var url = lstUrlFile[0]
                                $("<div/>").appendTo("body").dxCtrlPopupResizeImage({
                                    bddCtrl: option.bddCtrl,
                                    value: url,
                                    onValidation: function (url) {
                                        editorHtml.focus();
                                        //editorHtml.insertContent('<img src="' + encodeURIComponent(url) + '" style="max-width:100%;"/>');
                                        editorHtml.insertContent(
                                            editorHtml.dom.createHTML('img', { src: url, style: 'max-width:100%;' })
                                        );
                                    }
                                })
                                //var url = lstUrlFile[0];
                                //option.bddCtrl.mAjaxCall({
                                //    command: "migrein72dpiforemail",
                                //    urlimage: url
                                //}, function () {
                                //    editorHtml.focus();
                                //    editorHtml.insertContent('<img src="' + encodeURIComponent(url) + '" style="max-width:100%;"/>');
                                //})
                            }
                            pop.hide();
                        },
                        onHidden: function (e) { editorHtml.focus(); }
                    }).dxCtrlFileUploaderPopup("instance")
                }
            }
        })

        var svgLinkBox = '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M6.2 12.3a1 1 0 0 1 1.4 1.4l-2 2a2 2 0 1 0 2.6 2.8l4.8-4.8a1 1 0 0 0 0-1.4 1 1 0 1 1 1.4-1.3 2.9 2.9 0 0 1 0 4L9.6 20a3.9 3.9 0 0 1-5.5-5.5l2-2Zm11.6-.6a1 1 0 0 1-1.4-1.4l2-2a2 2 0 1 0-2.6-2.8L11 10.3a1 1 0 0 0 0 1.4A1 1 0 1 1 9.6 13a2.9 2.9 0 0 1 0-4L14.4 4a3.9 3.9 0 0 1 5.5 5.5l-2 2Z" fill-rule="nonzero"/>' +
            '<svg x="12" y="12" width="12" height="12" viewBox="0 0 640 640">' +
            '<path fill="' + theme.backgroundcolorAccent + '" d="M288 64L288 128C288 136.8 295.2 144 304 144L336 144C344.8 144 352 136.8 352 128L352 64L384 64C419.3 64 448 92.7 448 128L448 256C448 261.5 447.3 266.9 446 272L194 272C192.7 266.9 192 261.5 192 256L192 128C192 92.7 220.7 64 256 64L288 64zM384 576C372.8 576 362.2 573.1 353 568C362.5 551.5 368 532.4 368 512L368 384C368 363.6 362.5 344.5 353 328C362.2 322.9 372.7 320 384 320L416 320L416 384C416 392.8 423.2 400 432 400L464 400C472.8 400 480 392.8 480 384L480 320L512 320C547.3 320 576 348.7 576 384L576 512C576 547.3 547.3 576 512 576L384 576zM64 384C64 348.7 92.7 320 128 320L160 320L160 384C160 392.8 167.2 400 176 400L208 400C216.8 400 224 392.8 224 384L224 320L256 320C291.3 320 320 348.7 320 384L320 512C320 547.3 291.3 576 256 576L128 576C92.7 576 64 547.3 64 512L64 384z"/>' +
            '</svg>' +
            '</svg>'
        editorHtml.ui.registry.addIcon('linkbox' + indexInstance, svgLinkBox);
        editorHtml.ui.registry.addButton('linkbox' + indexInstance, {
            id: 'linkbox_' + indexInstance,
            icon: 'linkbox' + indexInstance,
            tooltip: 'Intégrer un lien sur un fichier de la box public',
            onAction: function (e) {
                var pop = $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                    bddCtrl: option.bddCtrl,
                    machine: false,
                    box: true,
                    icone: false,
                    imgInternet: false,
                    docCpt: false,
                    courrier: false,
                    multiple: false,
                    optionBox: {
                        allowRepertoirePublic: true,
                        allowRepertoirePartage: false,
                        allowRepertoireUti: false
                    },
                    onValide: function (lstUrlFile) {
                        if (lstUrlFile.length > 0) {
                            var fic = new cFichier(option.bddCtrl, lstUrlFile[0])
                            var url = fic.urlPublicAbsolue()
                            if (url.length > 0) {
                                editorHtml.execCommand('mceInsertContent', false, '<a href="' + url + '" target="_blank">' + url + '</a>');
                                mNotify("Vous avez inséré un lien sur un document de votre box public", "success", 6000)
                            }
                        }
                        pop.hide();
                    }
                }).dxCtrlFileUploaderPopup("instance")
            }
        })

        if (option.bddCtrl.objCptCli.objetMetier.hasSondage()) {
            var svgLinkSondage = '<svg width="24" height="24" viewBox="0 0 640 640" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M451.5 160C434.9 160 418.8 164.5 404.7 172.7C388.9 156.7 370.5 143.3 350.2 133.2C378.4 109.2 414.3 96 451.5 96C537.9 96 608 166 608 252.5C608 294 591.5 333.8 562.2 363.1L491.1 434.2C461.8 463.5 422 480 380.5 480C294.1 480 224 410 224 323.5C224 322 224 320.5 224.1 319C224.6 301.3 239.3 287.4 257 287.9C274.7 288.4 288.6 303.1 288.1 320.8C288.1 321.7 288.1 322.6 288.1 323.4C288.1 374.5 329.5 415.9 380.6 415.9C405.1 415.9 428.6 406.2 446 388.8L517.1 317.7C534.4 300.4 544.2 276.8 544.2 252.3C544.2 201.2 502.8 159.8 451.7 159.8zM307.2 237.3C305.3 236.5 303.4 235.4 301.7 234.2C289.1 227.7 274.7 224 259.6 224C235.1 224 211.6 233.7 194.2 251.1L123.1 322.2C105.8 339.5 96 363.1 96 387.6C96 438.7 137.4 480.1 188.5 480.1C205 480.1 221.1 475.7 235.2 467.5C251 483.5 269.4 496.9 289.8 507C261.6 530.9 225.8 544.2 188.5 544.2C102.1 544.2 32 474.2 32 387.7C32 346.2 48.5 306.4 77.8 277.1L148.9 206C178.2 176.7 218 160.2 259.5 160.2C346.1 160.2 416 230.8 416 317.1C416 318.4 416 319.7 416 321C415.6 338.7 400.9 352.6 383.2 352.2C365.5 351.8 351.6 337.1 352 319.4C352 318.6 352 317.9 352 317.1C352 283.4 334 253.8 307.2 237.5z" fill-rule="nonzero"/>' +
                '<svg x="224" y="224" width="416" height="416" viewBox="0 0 640 640">' +
                '<path fill="' + theme.backgroundcolorAccent + '" d="M439.4 96L448 96C483.3 96 512 124.7 512 160L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 160C128 124.7 156.7 96 192 96L200.6 96C211.6 76.9 232.3 64 256 64L384 64C407.7 64 428.4 76.9 439.4 96zM376 176C389.3 176 400 165.3 400 152C400 138.7 389.3 128 376 128L264 128C250.7 128 240 138.7 240 152C240 165.3 250.7 176 264 176L376 176zM320 312C336.1 312 349.2 325.1 349.2 341.2C349.2 349.9 346.1 355.1 342.3 358.9C337.8 363.3 331.6 366.4 325.5 368.4C310.6 373.4 296 387.7 296 407.9C296 421.2 306.7 431.9 320 431.9C331.5 431.9 341.2 423.8 343.5 412.9C362.7 405.8 397.2 386.6 397.2 341.1C397.2 298.5 362.6 263.9 320 263.9C277.4 263.9 242.8 298.5 242.8 341.1C242.8 354.4 253.5 365.1 266.8 365.1C280.1 365.1 290.8 354.4 290.8 341.1C290.8 325 303.9 311.9 320 311.9zM348 480C348 464.5 335.5 452 320 452C304.5 452 292 464.5 292 480C292 495.5 304.5 508 320 508C335.5 508 348 495.5 348 480z"/>' +
                '</svg>' +
                '</svg>'
            editorHtml.ui.registry.addIcon('linksondage' + indexInstance, svgLinkSondage);
            editorHtml.ui.registry.addButton('linksondage' + indexInstance, {
                id: 'linksondage_' + indexInstance,
                icon: 'linksondage' + indexInstance,
                tooltip: 'Intégrer un lien sur un sondage',
                onAction: function (e) {
                    var popupLstSondage = $("<div/>").appendTo("body").dxCtrlPopupBase({
                        position: {
                            my: "right top",
                            at: "right top",
                            of: "body"
                        },
                        width: 650,
                        height: "100%",
                        showTitle: true,
                        showMaximize: true,
                        title: "Choisir un sondage",
                        contentTemplate: function (contentElement) {
                            $("<div style='width:100%;height:100%;position:relative;'/>").appendTo(contentElement).dxCtrlGridSondage({
                                bddCtrl: option.bddCtrl,
                                showBtNew: false,
                                allowClick: true,
                                onClickDataGrid: function (container, dataGrid, dataTemplate) {
                                    var idSondage = dataGrid.id
                                    if (idSondage) {
                                        var url = option.bddCtrl.getObjet("sondage", idSondage).objetMetier.mGetUrlLink()
                                        if (url.length > 0) {
                                            editorHtml.execCommand('mceInsertContent', false, '<a href="' + url + '" target="_blank">' + url + '</a>');
                                            mNotify("Vous avez inséré un lien sur un sondage", "success", 6000)
                                        }
                                    }
                                    popupLstSondage.hide()
                                }
                            }).dxCtrlGridArticle("instance")
                        }
                    }).dxCtrlPopupBase("instance")
                    popupLstSondage.show();
                }
            })
        }

        if (parametre.code_appli == "ppmasc") {
            var svgLinkFormulaire = '<svg width="24" height="24" viewBox="0 0 640 640" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M451.5 160C434.9 160 418.8 164.5 404.7 172.7C388.9 156.7 370.5 143.3 350.2 133.2C378.4 109.2 414.3 96 451.5 96C537.9 96 608 166 608 252.5C608 294 591.5 333.8 562.2 363.1L491.1 434.2C461.8 463.5 422 480 380.5 480C294.1 480 224 410 224 323.5C224 322 224 320.5 224.1 319C224.6 301.3 239.3 287.4 257 287.9C274.7 288.4 288.6 303.1 288.1 320.8C288.1 321.7 288.1 322.6 288.1 323.4C288.1 374.5 329.5 415.9 380.6 415.9C405.1 415.9 428.6 406.2 446 388.8L517.1 317.7C534.4 300.4 544.2 276.8 544.2 252.3C544.2 201.2 502.8 159.8 451.7 159.8zM307.2 237.3C305.3 236.5 303.4 235.4 301.7 234.2C289.1 227.7 274.7 224 259.6 224C235.1 224 211.6 233.7 194.2 251.1L123.1 322.2C105.8 339.5 96 363.1 96 387.6C96 438.7 137.4 480.1 188.5 480.1C205 480.1 221.1 475.7 235.2 467.5C251 483.5 269.4 496.9 289.8 507C261.6 530.9 225.8 544.2 188.5 544.2C102.1 544.2 32 474.2 32 387.7C32 346.2 48.5 306.4 77.8 277.1L148.9 206C178.2 176.7 218 160.2 259.5 160.2C346.1 160.2 416 230.8 416 317.1C416 318.4 416 319.7 416 321C415.6 338.7 400.9 352.6 383.2 352.2C365.5 351.8 351.6 337.1 352 319.4C352 318.6 352 317.9 352 317.1C352 283.4 334 253.8 307.2 237.5z" fill-rule="nonzero"/>' +
                '<svg x="224" y="224" width="416" height="416" viewBox="0 0 32 32">' +
                '<g fill="' + theme.backgroundcolorAccent + '">' +
                '<rect width="4" height="4" x="26" y="2"/>' +
                '<rect width="4" height="4" x="26" y="8"/>' +
                '<rect width="4" height="4" x="20" y="2"/>' +
                '<rect width="4" height="4" x="20" y="8"/>' +
                '<path d="M28 16v6H4V6h12V4H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8v4H8v2h16v-2h-4v-4h8a2 2 0 0 0 2-2v-6zM18 28h-4v-4h4z"/>' +
                '</g>' +
                '</svg>' +
                '</svg>'
            editorHtml.ui.registry.addIcon('linkformulaire' + indexInstance, svgLinkFormulaire);
            editorHtml.ui.registry.addButton('linkformulaire' + indexInstance, {
                id: 'linkformulaire_' + indexInstance,
                icon: 'linkformulaire' + indexInstance,
                tooltip: 'Intégrer un lien sur un formulaire',
                onAction: function (e) {
                    var popupLstformulaire = $("<div/>").appendTo("body").dxCtrlPopupBase({
                        position: {
                            my: "right top",
                            at: "right top",
                            of: "body"
                        },
                        width: 650,
                        height: "100%",
                        showTitle: true,
                        showMaximize: true,
                        title: "Choisir un formulaire",
                        contentTemplate: function (contentElement) {
                            $("<div style='width:100%;height:100%;position:relative;'/>").appendTo(contentElement).dxCtrlGridFormulaire({
                                bddCtrl: option.bddCtrl,
                                showBtNew: false,
                                allowClick: true,
                                onClickDataGrid: function (container, dataGrid, dataTemplate) {
                                    var idFormulaire = dataGrid.id
                                    if (idFormulaire) {
                                        var url = option.bddCtrl.getObjet("formulaire", idFormulaire).objetMetier.mGetUrlLink()
                                        if (url.length > 0) {
                                            editorHtml.execCommand('mceInsertContent', false, '<a href="' + url + '" target="_blank">' + url + '</a>');
                                            mNotify("Vous avez inséré un lien sur un formulaire", "success", 6000)
                                        }
                                    }
                                    popupLstformulaire.hide()
                                }
                            }).dxCtrlGridFormulaire("instance")
                        }
                    }).dxCtrlPopupBase("instance")
                    popupLstformulaire.show();
                }
            })
        }

        if (typeof option.onDemandeTag != 'undefined') {
            editorHtml.ui.registry.addIcon('tag' + indexInstance, '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 384 512"><path d="M0 80V229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>');
            editorHtml.ui.registry.addButton('tag' + indexInstance, {
                id: 'tag_' + indexInstance,
                icon: 'tag' + indexInstance,
                text: 'Champ', // ✅ ajoute le texte à côté de l’icône
                tooltip: 'Insérez des champs de la base de données ou des liens (désinscription ou visu navigateur)',
                onAction: function (e) {
                    option.onDemandeTag(Me)
                }
            });
        }

        //button pour l'ia
        //if (option.allowIaReformulation && !parametre.isMobile) {
        editorHtml.ui.registry.addIcon('reformulationia' + indexInstance, '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 448 512"><path d="M370.7 96.1C346.1 39.5 289.7 0 224 0S101.9 39.5 77.3 96.1C60.9 97.5 48 111.2 48 128l0 64c0 16.8 12.9 30.5 29.3 31.9C101.9 280.5 158.3 320 224 320s122.1-39.5 146.7-96.1c16.4-1.4 29.3-15.1 29.3-31.9l0-64c0-16.8-12.9-30.5-29.3-31.9zM336 144l0 16c0 53-43 96-96 96l-32 0c-53 0-96-43-96-96l0-16c0-26.5 21.5-48 48-48l128 0c26.5 0 48 21.5 48 48zM189.3 162.7l-6-21.2c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6zM112.7 316.5C46.7 342.6 0 407 0 482.3C0 498.7 13.3 512 29.7 512l98.3 0 0-64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 64 98.3 0c16.4 0 29.7-13.3 29.7-29.7c0-75.3-46.7-139.7-112.7-165.8C303.9 338.8 265.5 352 224 352s-79.9-13.2-111.3-35.5zM176 448c-8.8 0-16 7.2-16 16l0 48 32 0 0-48c0-8.8-7.2-16-16-16zm96 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"/></svg>');
        var tooltip = 'Reformuler le texte sélectionné avec MIA<br/>(Cliquez droit pour<br/>la configuration de la reformulation)'
        editorHtml.ui.registry.addButton('reformulationia' + indexInstance, {
            id: 'reformulationia_' + indexInstance,
            icon: 'reformulationia' + indexInstance,
            tooltip: tooltip,
            onAction: function (e) {

                var selection = false
                var txt = editorHtml.selection.getContent({ format: 'html' })
                if (txt.length == 0) {
                    //pas de sélection
                    txt = Me.mGetContentSansBody().trim()
                } else {
                    selection = true
                }

                var $temp = $("<div>").html(txt);
                if ($temp.find("img").length > 0) {
                    mNotify(((selection) ? "Le texte sélectionné" : "Votre texte") + " contient des images.<br/>Il est impossible de reformuler un texte incluant des images.<br/>Veuillez sélectionner uniquement du texte sans images.", "warning", 60000)
                    return
                }

                var dxTranslate = $("<div/>").appendTo("body").dxCtrlIaReformule({
                    bddCtrl: option.bddCtrl,
                    text: txt,
                    isInPopup: true,
                    onValide: function (html) {
                        if (selection) { editorHtml.selection.setContent(html); }
                        else { editorHtml.setContent(html); }
                        isDirty = true
                        dxTranslate.element().remove()
                        dxTranslate = null
                    }
                }).dxCtrlIaReformule("instance")
            }
        });
        //}

        //if (option.allowIaTranslate && !parametre.isMobile) {
        var tooltip = 'Traduire le texte sélectionné avec MIA<br/>(Cliquez droit pour<br/>la configuration de la traduction)'
        editorHtml.ui.registry.addMenuButton('cboTranslateIa' + indexInstance, {
            text: 'Traduire',
            tooltip: tooltip,
            fetch: function (callback) {
                var lstOption = []
                var selection = false
                var txt = editorHtml.selection.getContent({ format: 'html' })
                if (txt.length == 0) {
                    //pas de sélection
                    txt = Me.mGetContentSansBody().trim()
                } else {
                    selection = true
                }

                var $temp = $("<div>").html(txt);
                if ($temp.find("img").length > 0) {
                    mNotify(((selection) ? "Le texte sélectionné" : "Votre texte") + " contient des images.<br/>Il est impossible de traduire un texte incluant des images.<br/>Veuillez sélectionner uniquement du texte sans images.", "warning", 60000)
                    return
                }

                langueIA.forEach(function (lang) {
                    var opt = { type: 'menuitem', text: lang.label }
                    opt.onAction = function () {
                        var selection = false
                        var txt = editorHtml.selection.getContent({ format: 'html' })
                        if (txt.length == 0) {
                            //pas de sélection
                            txt = Me.mGetContentSansBody().trim()
                        } else {
                            selection = true
                        }

                        var $temp = $("<div>").html(txt);
                        if ($temp.find("img").length > 0) {
                            mNotify(((selection) ? "Le texte sélectionné" : "Votre texte") + " contient des images.<br/>Il est impossible de traduire un texte incluant des images.<br/>Veuillez sélectionner uniquement du texte sans images.", "warning", 60000)
                            return
                        }

                        var dxTranslate = $("<div/>").appendTo("body").dxCtrlIaReformule({
                            bddCtrl: option.bddCtrl,
                            text: txt,
                            isInPopup: true,
                            traduire: true,
                            langueIA: lang.code,
                            onValide: function (html) {
                                if (selection) { editorHtml.selection.setContent(html); }
                                else { editorHtml.setContent(html); }
                                isDirty = true
                                dxTranslate.element().remove()
                                dxTranslate = null
                            }
                        }).dxCtrlIaReformule("instance")
                    }
                    lstOption.push(opt)
                })
                callback(lstOption);
            }
        });
        //}

        ////button pour cacher/montrer le menu
        //editorHtml.ui.registry.addIcon('showhidemenu' + indexInstance, '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="100 0 320 512"><path d="M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"/></svg>');
        editorHtml.ui.registry.addButton('showhidemenu' + indexInstance, {
            id: 'menu_' + indexInstance,
            text: '⇅',
            //icon: 'showhidemenu' + indexInstance,
            tooltip: 'Montrer/cacher le menu',
            onAction: function () {
                Me.showHideMenu();
                editorHtml.focus()
            }
        });
    }

    this.showHideMenu = function (visible) {
        var $Menu = container.find(".tox-menubar")
        if (typeof visible == 'undefined') {
            $Menu.css("display", (($Menu.is(":visible")) ? "none" : ""));
        } else {
            $Menu.css("display", ((!visible) ? "none" : ""));
        }
        if (Me.isInit && typeof option.onShowHideMenu != 'undefined') option.onShowHideMenu($Menu.is(":visible"))
    }

    this.getCurrentEditorHtml = function () { return editorHtml }

    this.mGetContent = function () {
        var html = editorHtml.getContent()
        return html
    }

    this.mGetContentSansBody = function () {
        //if (parametre.code_appli == "ppmasc" || option.bddCtrl.nom_base =="masc_dahutemeraire") {
        var html = editorHtml.getContent()
        return html
        //} else {
        //    var html = editorHtml.getContent()
        //    html = html.split("<body")[1]
        //    html = html.substring(html.indexOf(">") + 1)
        //    html = html.split("</body>")[0]
        //    return html
        //}
        ////var html = editorHtml.getContent()
        ////html = html.split("<body")[1]
        ////html = html.substring(html.indexOf(">") + 1)
        ////html = html.split("</body>")[0]
        ////return html
    }

    this.element = function () { return container }

    mConstruit();
}